import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { SareeCard } from "../components/SareeCard";

export default function Wishlist() {
  const { items } = useWishlist();

  return (
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12 py-12" data-testid="wishlist-page">
      <span className="caption">Saved for later</span>
      <h1 className="font-serif text-4xl sm:text-5xl text-gold-light mt-2 flex items-center gap-3">
        <Heart className="w-8 h-8 fill-gold text-gold" /> Your Wishlist
      </h1>

      {items.length === 0 ? (
        <div className="glass rounded-lg p-16 text-center mt-10" data-testid="wishlist-empty">
          <Heart className="w-10 h-10 text-gold/40 mx-auto" />
          <p className="text-gold-muted mt-4 font-serif text-xl">Nothing saved yet</p>
          <p className="text-sm text-muted-foreground mt-1">Tap the heart on any saree to keep it here.</p>
          <Link to="/collection" className="inline-block mt-6 bg-gold text-obsidian font-semibold px-6 py-3 rounded-full hover:bg-gold-light transition-colors">
            Explore the collection
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-10">
          {items.map((p, i) => <SareeCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
